var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"appeals-status","route":"/reports/billing-appeals-status","file-name":"recursos-e-recuperacao.xlsx","period-label":"Período do recurso","columns":_vm.columns}})
}
var staticRenderFns = []

export { render, staticRenderFns }